import { useContext, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SttTabs, AppContext } from '../../../sporttia/all';
import { Paper, Box } from '@mui/material';
import AdminsTab from './AdminsTab';
import RolesTab from './RolesTab';

type Props = Record<string, never>;

const TAB_KEYS = {
    administrators: 'administrators',
    roles: 'roles',
} as const;

export default function Roles({}: Props): React.ReactElement {
    const { t } = useTranslation();
    const cxt = useContext(AppContext);
    const [searchParams] = useSearchParams();

    const tabs = [
        {
            key: TAB_KEYS.administrators,
            caption: t('Administrators'),
            component: <AdminsTab />,
        },
        {
            key: TAB_KEYS.roles,
            caption: t('Roles'),
            component: <RolesTab />,
        },
    ];

    // Get current tab title based on URL param
    const getCurrentTitle = (tabKey: string): string => {
        const tab = tabs.find((t) => t.key === tabKey);
        return tab?.caption || t('Administrators');
    };

    // Update header when tab changes
    useEffect(() => {
        const tabParam = searchParams.get('tab') || TAB_KEYS.administrators;
        cxt?.setHeader({
            title: getCurrentTitle(tabParam),
        });
    }, [searchParams]);

    // -----| Render |-----
    return (
        <Paper className="overflow-hidden">
            <Box p={3}>
                {/* El título lo pinta la cabecera compartida a partir de
                    cxt.setHeader(), que se actualiza al cambiar de pestaña. */}
                <SttTabs tabs={tabs} urlParam="tab" />
            </Box>
        </Paper>
    );
}
